(function () { 
  var STORAGE_KEY = 'elegance-theme';
  var LIGHT = 'light';
  var DARK = 'dark';
  var root = document.documentElement;

  function get() {
    return root.getAttribute('data-theme') === DARK ? DARK : LIGHT;
  }

  function syncMetaThemeColor() {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    var hex = getComputedStyle(root).getPropertyValue('--color-bg-hex').trim();
    if (hex) meta.setAttribute('content', hex);
  }

  function syncButtons() {
    var isDark = get() === DARK;
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', isDark ? 'true' : 'false');
    }
  }

  function set(mode) {
    if (mode === DARK) {
      root.setAttribute('data-theme', DARK);
    } else {
      root.removeAttribute('data-theme');
      mode = LIGHT;
    }
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
    syncButtons();
    syncMetaThemeColor();
    document.dispatchEvent(new CustomEvent('elegance:themechange', { detail: { theme: mode } }));
  }

  function toggle() {
    set(get() === DARK ? LIGHT : DARK);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle();
  });
 
  document.addEventListener('shopify:section:load', syncButtons);

  function init() {
    syncButtons();
    syncMetaThemeColor();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EleganceTheme = { get: get, set: set, toggle: toggle };
})();
